import {Component, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FrtAccessorialsMasterService} from '../../services/frt-accessorials-master/frt-accessorials-master.service';
import {FrtAcessorialsMaster, RatesFrtAccessorialsProcure} from '../../shared/common-components/common-structure';
import {LoadingService} from '../../services/loading/loading.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {AlertService} from 'src/app/services/alert/alert.service';
import {rateAmountValidator, minChargeValidator} from './validators';
import {PaginationComponent} from "../../shared/pagination/pagination.component";
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-frt-edit-rates-accessorials',
    templateUrl: './frt-edit-rates-accessorials.component.html',
    styleUrls: ['./frt-edit-rates-accessorials.component.css'],
    imports: [
        PaginationComponent,
        ReactiveFormsModule, NgFor, NgIf
    ]
})
export class FrtEditRatesAccessorialsComponent implements OnInit {
  carrierId: any;
  sroMasterId: any;
  rateTypeId: any;
  frtRateAccessorialsFormGroup: UntypedFormGroup;
  frtAccessorials: RatesFrtAccessorialsProcure[] = [];
  frtEditAccList: RatesFrtAccessorialsProcure[] = [];
  frtDeleteAccList: number[] = [];
  frtAccMast: FrtAcessorialsMaster[] = [];
  editButtonText: string;
  minCharge: number;
  maxCharge: number;
  changeTypes = [
    'Delete', 'Modify'
  ];
  modalRef: BsModalRef;
  tmssloader;
  accdesc: string;

  itemsPerPage = 10;
  totalItems = 0;
  currentPage = 1;
  pageReset = false;
  previousPage = 0;
  resultsPage: any = null;
  pageMap: Map<number, any> = new Map<number, any>();
  showingStart: number;
  showingEnd: number;

  constructor(private formBuilder: UntypedFormBuilder,
              private frtAccessorialsMasterService: FrtAccessorialsMasterService,
              private bsModalRef: BsModalRef,
              private loader: LoadingService,
              private alertService: AlertService,
              private modalService: BsModalService) {
    this.tmssloader = this.loader;
  }

  ngOnInit() {
    this.initializeFrtForm();
    this.search();
  }
  /**
   * @description populates Accessorials table
   */
  search() {
    this.frtEditAccList = [];
    this.frtDeleteAccList = [];
    this.editButtonText = 'Update';
    this.loader.show();
    this.frtAccessorialsMasterService.getFrtAcessorialsMasterByCarrierId(
      this.carrierId, this.sroMasterId).subscribe(FrtAcessorials => {
      this.frtAccessorials = FrtAcessorials;
      this.totalItems = this.frtAccessorials.length;
      if (this.totalItems > 0) {
      // this.showTable = true;
      this.setupPagination();
      } else {
      while ((<UntypedFormArray>this.frtRateAccessorialsFormGroup.get('accessorials')).length !== 0) {
        (<UntypedFormArray>this.frtRateAccessorialsFormGroup.get('accessorials')).removeAt(0);
      }
      this.alertService.info('There are no rate records for this selection criteria!!!');
    }
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('Error while retreiving accessorials for the TSP');
    });
  }

  /**
   * @description initializes the FRT Accessorial form
   */
  initializeFrtForm() {
    this.frtRateAccessorialsFormGroup = this.formBuilder.group({
      accessorials: new UntypedFormArray([])
    });
  }
  /*
  * @description getFormField for hhgCarrierRates
  * */
  getFormField(field: string): any {
    return this.frtRateAccessorialsFormGroup.get(field);
  }

  onChangeType(index) {
    const element = this.frtRateAccessorialsFormGroup.get('accessorials').get(index);
  }
  /**
   * @description Listens to Rate Amount changes
   */
  onSelectRateAmount(rateAmount: number, accProcureId: number) {
    let found = 0;
    const i = 0;
    this.frtEditAccList.forEach(e => {
      if (e.accessorialProcureId === accProcureId) {
        found = 1;
        e.accessorialAmount = rateAmount;
      }
    });
    if (found === 0) {
      this.frtAccessorials.forEach(e => {
        if (e.accessorialProcureId === accProcureId) {
          e.accessorialAmount = rateAmount;
          this.frtEditAccList.push(e);
        }
      });
    }
  }
  /**
   * @description Listenes to Minimum Charge changes
   */
  onSelectMinimumCharge(minimunAmount: number, accProcureId: number) {
    let found = 0;
    const i = 0;
    this.frtEditAccList.forEach(e => {
      if (e.accessorialProcureId === accProcureId) {
        found = 1;
        e.minimumAmount = minimunAmount;
      }
    });
    if (found === 0) {
      this.frtAccessorials.forEach(e => {
        if (e.accessorialProcureId === accProcureId) {
          e.minimumAmount = minimunAmount;
          this.frtEditAccList.push(e);
        }
      });
    }
  }
  /**
   * @description Listens to the user selction of delete check box
   */
  onSelectDelete(isChecked: boolean, accProcureId: number) {
    if (isChecked) {
      this.frtDeleteAccList.push(accProcureId);
    } else {
      const index: number = this.frtDeleteAccList.indexOf(accProcureId);
      if (index !== -1) {
        this.frtDeleteAccList.splice(index, 1);
      }
    }
    if (this.frtDeleteAccList.length > 0) {
      this.editButtonText = 'Delete';
    } else {
      this.editButtonText = 'Update';
    }
  }
  /**
   * @description Helper function to call either delete or Update function.
   */
  saveAcc() {
    if (this.frtDeleteAccList.length > 0) {
      this.delete();
    }
    if (this.frtEditAccList.length > 0) {
      this.update();
    }

  }
  /**
   * @description Deletes the selected records.
   */
  delete() {
    if (this.frtDeleteAccList !== null) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to delete these Accessorials records?';
      this.modalRef.content.title = 'USER DELETE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.tmssloader.show();
          this.frtAccessorialsMasterService.deleteFrtRatesAccProcure(this.frtDeleteAccList).subscribe(response => {
            this.search();
            this.tmssloader.hide();
            this.alertService.info(response.response);
          });
        }
      });
    }
  }
  /**
   * @description Updates the the records where the data is modified
   */
  update() {
    if (this.frtEditAccList.length > 0) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to edit these rate records?';
      this.modalRef.content.title = 'USER UPDATE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.tmssloader.show();
          this.frtAccessorialsMasterService.updateFrtRatesAccProcure(this.frtEditAccList).subscribe(response => {
            this.tmssloader.hide();
            this.alertService.info(response.response);
          });
        }
      });
    } else {
      this.alertService.info('No records are selected for modification!!!');
    }
  }



  /**
   * @description closes the modal using ng bootstrap as the injector is local to the component class
   */
  closeModal() {
    this.bsModalRef.hide();
  }
  /**
   * @description Binds the json response from the service to the FormArray
   */
  setupAccessorialsTable(accrecords: any) {
    const len = (<UntypedFormArray>this.frtRateAccessorialsFormGroup.get('accessorials')).length;
    while ((<UntypedFormArray>this.frtRateAccessorialsFormGroup.get('accessorials')).length !== 0) {
      (<UntypedFormArray>this.frtRateAccessorialsFormGroup.get('accessorials')).removeAt(0);
    }
    for (const accrecord of accrecords) {
      const accdesc = accrecord.frtAccessorialsMasterEntity.accessorialCode + '-' +
                    accrecord.frtAccessorialsMasterEntity.accessorialDescription;
      this.minCharge = accrecord.frtAccessorialsMasterEntity.minCharge;
      this.maxCharge = accrecord.frtAccessorialsMasterEntity.maxCharge;
      const grp = this.formBuilder.group(
        { Delete: [''],
          AccessorialCode: [accdesc],
          RateAmount: [accrecord.accessorialAmount, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'),
            rateAmountValidator(this.maxCharge)]],
          MinimumCharge: [accrecord.minimumAmount, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'),
            minChargeValidator(this.minCharge)]],
          accProcureId: [accrecord.accessorialProcureId],
          RateAmtLimit: [this.maxCharge],
          MinChgLimit: [this.minCharge]
        });
        (<UntypedFormArray>this.frtRateAccessorialsFormGroup.get('accessorials')).push(grp);
    }


  }
  // Set Up Pagination Map
  setupPagination() {
    this.pageMap = new Map<number, any>();
    let pageCount = 1;

    for (let i = 0; i < this.totalItems; i = i + this.itemsPerPage) {
      const pageOfHhgRateEdit = this.frtAccessorials.slice(i, i + this.itemsPerPage);
      this.pageMap.set(pageCount, pageOfHhgRateEdit);
      pageCount++;
    }
    // Reset the current page to the first page
    this.currentPage = 1;
    this.resultsPage = this.pageMap.get(this.currentPage);
    if (this.currentPage === 1) {
      this.setupAccessorialsTable(this.resultsPage);
    }
    this.showingStart = 1;
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
  }

  page(currentPage: number) {
    this.currentPage = currentPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.resultsPage = this.pageMap.get(currentPage);
      if (this.currentPage > 0) {
        this.setupAccessorialsTable(this.resultsPage);
      }
    }
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
    this.showingStart = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1;
  }

  itemsPerPageChanged(itemsPerPage: any) {
    this.itemsPerPage = itemsPerPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.setupPagination();
      this.pageReset = true;
    }
  }
}
